<template>
  <div class="tableRow">
    <div class="tableRow__main">
      <sm-modal v-if="modal.show" @close="modal.show = !modal.show">
        <template #header>
          ¿Cambiar estado de {{ statusMsg[user.status] }} a {{ statusMsg[modal.status] }} ?
        </template>

        <template #default>
          <sm-input
            placeholder="Añadir comentario (opcional)"
            size="small"
            inputStyle="width: 400px; margin-left: 10px;"
            v-model="modal.observation"
          />
          <sm-input
            v-if="modal.status === 'payed'"
            :placeholder="modal.amountError ? modal.amountError : 'Indicar monto'"
            :error="modal.amountError ? true : false"
            size="small"
            inputStyle="width: 400px; margin-left: 10px;"
            v-model="modal.amount"
          />
        </template>

        <template #footer>
          <sm-button
            label="Confirmar"
            size="small"
            @click="confirmHandler"
          />
        </template>
      </sm-modal>

      <div class="tableRow__main__item1">
        <div @click="toggleRowPlus" class="tableRow__main__item1__icon-container">
          <sm-icon
            icon="add-outline"
            class="tableRow__main__item1__icon-container__icon"
          />
        </div>
        <div class="tableRow__main__item1__text">{{ user.name }}</div>
      </div>

      <div class="tableRow__main__item2">
        <div class="tableRow__main__item2__text">{{ statusMsg[user.status] }}</div>
      </div>

      <div class="tableRow__main__item3">
        <div
          class="tableRow__main__item3__text"
        >
          {{ user.amount || '-' }}
        </div>
      </div>

      <div class="tableRow__main__item4">
        <div class="tableRow__main__item4__text">{{ user.updatedAt.split('T')[0] }}</div>
      </div>

      <div class="tableRow__main__item5">
        <sm-tooltip :followCursor="true">
          <template v-slot:trigger>
            <svg
              :style="{cursor: isPossible(user.status, 'in-study') ? 'pointer' : 'not-allowed'}"
              @click="isPossible(user.status, 'in-study') ? openModal('study') : null"
              @mouseover="icon.isHoverOn['in-study'] = true"
              @mouseleave="icon.isHoverOn['in-study'] = false"
              width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path :fill="iconColorHandler('in-study')" fill-rule="evenodd" clip-rule="evenodd" d="M4.80457 0.28125C4.09956 0.28125 3.52803 0.852778 3.52803 1.55779V2.8241H1.76092C1.0559 2.8241 0.484375 3.39563 0.484375 4.10064V15.7232C0.484375 16.4282 1.0559 16.9997 1.76092 16.9997H10.9125C11.6175 16.9997 12.189 16.4282 12.189 15.7232V14.4569H13.9562C14.6612 14.4569 15.2327 13.8853 15.2327 13.1803V3.56046C15.2327 3.15939 15.0504 2.78006 14.7372 2.52953L12.2879 0.570471C12.0539 0.383248 11.7631 0.28125 11.4633 0.28125H4.80457ZM11.0837 6.01758C11.0944 6.0444 11.1 6.0733 11.1 6.10288V14.4569H11.1002V15.7232C11.1002 15.8268 11.0162 15.9109 10.9125 15.9109H1.76092C1.65724 15.9109 1.5732 15.8268 1.5732 15.7232V4.10064C1.5732 3.99697 1.65725 3.91293 1.76092 3.91293H8.41967C8.47219 3.91293 8.52315 3.9308 8.56417 3.96361L11.0134 5.92267C11.045 5.94799 11.0691 5.98083 11.0837 6.01758ZM12.189 13.368H13.9562C14.0598 13.368 14.1439 13.284 14.1439 13.1803V3.56046C14.1439 3.49019 14.1119 3.42372 14.057 3.37982L11.6078 1.42076C11.5668 1.38795 11.5158 1.37008 11.4633 1.37008H4.80457C4.7009 1.37008 4.61686 1.45412 4.61686 1.55779V2.82366H8.4195C8.71923 2.82366 9.01004 2.92566 9.24411 3.11289L11.6933 5.07195C11.8757 5.21781 12.0137 5.40734 12.0972 5.6194C12.1572 5.77168 12.189 5.9356 12.189 6.10332V13.368ZM3.77741 12.4648C3.57536 12.4648 3.41157 12.6285 3.41157 12.8306C3.41157 13.0326 3.57536 13.1964 3.77741 13.1964H8.89701C9.09906 13.1964 9.26285 13.0326 9.26285 12.8306C9.26285 12.6285 9.09906 12.4648 8.89701 12.4648H3.77741ZM3.77785 14.0457C3.5758 14.0457 3.41201 14.2095 3.41201 14.4116C3.41201 14.6136 3.5758 14.7774 3.77785 14.7774H8.89745C9.0995 14.7774 9.2633 14.6136 9.2633 14.4116C9.2633 14.2095 9.0995 14.0457 8.89745 14.0457H3.77785ZM4.66952 5.5228L5.90196 6.98189H5.03159V7.56584L6.33666 8.30396L7.64173 7.56584V6.98189H6.77136L8.0038 5.5228L9.23625 6.98189L8.36762 6.98189V7.77754C8.36762 7.90835 8.29722 8.02905 8.18335 8.09345L7.0739 8.72093L8.48587 9.51951C8.59973 9.58391 8.67013 9.70461 8.67013 9.83543V11.2017C8.67013 11.4021 8.50764 11.5646 8.30719 11.5646C8.10674 11.5646 7.94425 11.4021 7.94425 11.2017V10.0471L6.33666 9.1379L4.72907 10.0471V11.2017C4.72907 11.4021 4.56658 11.5646 4.36613 11.5646C4.16568 11.5646 4.00319 11.4021 4.00319 11.2017V9.83543C4.00319 9.70461 4.07359 9.58391 4.18746 9.51951L5.59942 8.72093L4.48997 8.09345C4.37611 8.02905 4.30571 7.90835 4.30571 7.77754L4.30571 6.98189H3.43708L4.66952 5.5228Z" />
            </svg>
          </template>
          <span v-show="user.status === 'in-study'">
            En proceso de estudio de crédito
          </span>
          <span v-show="user.status === 'interested'">
            En proceso de estudio de crédito
          </span>
          <span v-show="user.status !== 'interested' && user.status !== 'in-study'">
            En proceso de estudio de crédito (No disponible)
          </span>
        </sm-tooltip>
        <sm-tooltip :followCursor="true">
          <template v-slot:trigger>
            <svg
              :style="{cursor: isPossible(user.status, 'non-applicable') ? 'pointer' : 'not-allowed'}"
              @click="isPossible(user.status, 'non-applicable') ? openModal('skip') : null"
              @mouseover="icon.isHoverOn['non-applicable'] = true"
              @mouseleave="icon.isHoverOn['non-applicable'] = false"
              width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle :stroke="iconColorHandler('non-applicable')" cx="7" cy="7" r="6.25" stroke-width="1.5"/>
              <line :stroke="iconColorHandler('non-applicable')" x1="2.46967" y1="11.4697" x2="11.4697" y2="2.46967" stroke-width="1.5"/>
            </svg>
          </template>
          <span v-show="user.status === 'non-applicable'">
            No cumplió con requisitos para empezar un estudio de crédito
          </span>
          <span v-show="user.status === 'interested'">
            No cumple con requisitos para empezar un estudio de crédito
          </span>
          <span v-show="user.status !== 'interested' && user.status !== 'non-applicable'">
            Cumplió con requisitos para empezar un estudio de crédito
          </span>
        </sm-tooltip>
        <sm-tooltip :followCursor="true">
          <template v-slot:trigger>
            <svg
              :style="{cursor: isPossible(user.status, 'rejected') ? 'pointer' : 'not-allowed'}"
              @click="isPossible(user.status, 'rejected') ? openModal('reject') : null"
              @mouseover="icon.isHoverOn.rejected = true"
              @mouseleave="icon.isHoverOn.rejected = false"
              width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path :fill="iconColorHandler('rejected')" fill-rule="evenodd" clip-rule="evenodd" d="M0.730124 0.68404C1.13304 0.30631 1.76587 0.326724 2.1436 0.729636L6.41407 5.2848L10.6845 0.729636C11.0623 0.326724 11.6951 0.30631 12.098 0.68404C12.5009 1.06177 12.5213 1.69461 12.1436 2.09752L7.7848 6.74691L12.1436 11.3963C12.5213 11.7992 12.5009 12.4321 12.098 12.8098C11.6951 13.1875 11.0623 13.1671 10.6845 12.7642L6.41407 8.20903L2.1436 12.7642C1.76587 13.1671 1.13304 13.1875 0.730125 12.8098C0.327212 12.4321 0.306798 11.7992 0.684529 11.3963L5.04333 6.74691L0.684529 2.09752C0.306798 1.69461 0.327212 1.06177 0.730124 0.68404Z" />
            </svg>
          </template>
          <span v-show="user.status === 'rejected'">
            Crédito rechazado
          </span>
          <span v-show="user.status === 'in-study'">
            Rechazar crédito
          </span>
          <span v-show="user.status !== 'in-study' && user.status !== 'rejected'">
            Rechazar crédito (No disponible)
          </span>
        </sm-tooltip>
        <sm-tooltip :followCursor="true">
          <template v-slot:trigger>
            <svg
              :style="{cursor: isPossible(user.status, 'approved') ? 'pointer' : 'not-allowed'}"
              @click="isPossible(user.status, 'approved') ? openModal('approve') : null"
              @mouseover="icon.isHoverOn.approved = true"
              @mouseleave="icon.isHoverOn.approved = false"
              width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path :stroke="iconColorHandler('approved')" d="M1 8.05882L4.12118 12.8783C4.15924 12.9371 4.24435 12.9395 4.28575 12.8831L13 1" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </template>
          <span v-show="user.status === 'approved'">
            Crédito aprobado
          </span>
          <span v-show="user.status === 'in-study'">
            Aprobar crédito
          </span>
          <span v-show="user.status !== 'in-study' && user.status !== 'approved'">
            Aprobar crédito (No disponible)
          </span>
        </sm-tooltip>
        <sm-tooltip :followCursor="true">
          <template v-slot:trigger>
            <svg
              :style="{cursor: isPossible(user.status, 'payed') ? 'pointer' : 'not-allowed'}"
              @click="isPossible(user.status, 'payed') ? openModal('payed') : null"
              @mouseover="icon.isHoverOn.payed = true"
              @mouseleave="icon.isHoverOn.payed = false"
              width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path :fill="iconColorHandler('payed')" d="M6.67676 11.8208C6.67676 11.367 6.54948 11.0073 6.29492 10.7417C6.0459 10.4705 5.61979 10.2215 5.0166 9.99463C4.41341 9.76774 3.89323 9.54362 3.45605 9.32227C3.01888 9.09538 2.64258 8.83805 2.32715 8.55029C2.01725 8.257 1.77376 7.9139 1.59668 7.521C1.42513 7.12809 1.33936 6.66048 1.33936 6.11816C1.33936 5.18294 1.63818 4.4165 2.23584 3.81885C2.8335 3.22119 3.6276 2.87256 4.61816 2.77295V0.996582H5.94629V2.79785C6.92578 2.9362 7.69222 3.3457 8.24561 4.02637C8.79899 4.7015 9.07568 5.57861 9.07568 6.65771H6.67676C6.67676 5.99365 6.53841 5.49837 6.26172 5.17188C5.99056 4.83984 5.62533 4.67383 5.16602 4.67383C4.71224 4.67383 4.36084 4.80387 4.11182 5.06396C3.86279 5.31852 3.73828 5.67269 3.73828 6.12646C3.73828 6.54704 3.86003 6.8846 4.10352 7.13916C4.34701 7.39372 4.79801 7.65381 5.45654 7.91943C6.12061 8.18506 6.66569 8.43685 7.0918 8.6748C7.5179 8.90723 7.8776 9.17285 8.1709 9.47168C8.46419 9.76497 8.68831 10.1025 8.84326 10.4844C8.99821 10.8607 9.07568 11.3006 9.07568 11.8042C9.07568 12.745 8.78239 13.5086 8.1958 14.0952C7.60921 14.6818 6.80127 15.0277 5.77197 15.1328V16.7847H4.45215V15.1411C3.31771 15.0194 2.43783 14.6182 1.8125 13.9375C1.19271 13.2513 0.882812 12.341 0.882812 11.2065H3.28174C3.28174 11.8651 3.43669 12.3714 3.74658 12.7256C4.06201 13.0742 4.51302 13.2485 5.09961 13.2485C5.58659 13.2485 5.97119 13.1213 6.25342 12.8667C6.53564 12.6066 6.67676 12.258 6.67676 11.8208Z" />
            </svg>
          </template>
          <span v-show="user.status === 'payed'">
            El usuario ya recibió el dinero
          </span>
          <span v-show="user.status === 'approved'">
            Desembolsar crédito
          </span>
          <span v-show="user.status !== 'approved' && user.status !== 'payed'">
            Desembolsar crédito (No disponible)
          </span>
        </sm-tooltip>
      </div>

      <div class="tableRow__main__item6">
        <div
          class="tableRow__main__item6__text"
        >
          {{ user.observation || '-' }}
        </div>
      </div>
    </div>

    <div v-show="!rowPlus" class="tableRow__line"></div>
    <div v-show="rowPlus" class="tableRow__line--gray"></div>

    <transition name="tableRow-fade">
      <div v-show="rowPlus" class="tableRow__plus">
        <div class="tableRow__plus__header">
          <div class="tableRow__plus__header__text">
            <div class="tableRow__plus__header__text__circle">Datos de empresa</div>
          </div>
          <div class="tableRow__plus__header__text">
            <div class="tableRow__plus__header__text__down">Empresa</div>
          </div>
          <div class="tableRow__plus__header__text">
            <div class="tableRow__plus__header__text__down">Contacto</div>
          </div>
        </div>

        <div class="tableRow__plus__container">
          <div class="tableRow__plus__container__item tableRow__plus__container__item--gray">Nombre de empresa</div>
          <div class="tableRow__plus__container__item">{{ user.name }}</div>

          <div class="tableRow__plus__container__item tableRow__plus__container__item--gray">{{ user.data.identificationType }}</div>
          <div class="tableRow__plus__container__item">{{ user.data.identification }}</div>

          <div class="tableRow__plus__container__item tableRow__plus__container__item--gray">Facturación mensual</div>
          <div class="tableRow__plus__container__item">{{ user.data.total }}</div>

          <div class="tableRow__plus__container__item tableRow__plus__container__item--gray">País</div>
          <div class="tableRow__plus__container__item">{{ user.data.countryName }}</div>

          <div class="tableRow__plus__container__item tableRow__plus__container__item--gray">Ciudad</div>
          <div class="tableRow__plus__container__item">{{ user.data.city }}</div>

          <div class="tableRow__plus__container__item tableRow__plus__container__item--gray">Sector</div>
          <div class="tableRow__plus__container__item">{{ user.data.sector }}</div>

          <div class="tableRow__plus__container__item tableRow__plus__container__item--gray">Persona</div>
          <div class="tableRow__plus__container__item">{{ user.data.kindOfPerson }}</div>

          <div class="tableRow__plus__container__item tableRow__plus__container__item--gray">Tiempo en Alegra</div>
          <div class="tableRow__plus__container__item">{{ user.data.dateRegistry }}</div>

          <div class="tableRow__plus__container__item--contact">
            <div class="tableRow__plus__container__item--contact__profile">
              <div class="tableRow__plus__container__item--contact__profile__pic">J</div>
              <div class="tableRow__plus__container__item--contact__profile__data">
                <div class="tableRow__plus__container__item--contact__profile__data__name">{{ user.data['users.name'] }}</div>
                <div class="tableRow__plus__container__item--contact__profile__data__headline">{{ user.data['users.position'] }}</div>
              </div>
            </div>

            <div class="tableRow__plus__container__item--contact__label">E-mail</div>
            <div class="tableRow__plus__container__item--contact__text">{{ user.data['users.email'] }}</div>

            <div class="tableRow__plus__container__item--contact__label">Celular</div>
            <div class="tableRow__plus__container__item--contact__text">{{ user.data.mobile }}</div>

            <div class="tableRow__plus__container__item--contact__label">Teléfono</div>
            <div class="tableRow__plus__container__item--contact__text">{{ user.data.phone }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'tableRow',
  props: {
    user: Object
  },
  data () {
    return {
      rowPlus: false,
      modal: {
        show: false,
        status: '',
        observation: '',
        amount: null
      },
      statusMsg: {
        'non-applicable': 'No aplica',
        study: 'En estudio de crédito',
        approve: 'Aprobado',
        reject: 'Rechazado',
        payed: 'Desembolsado',
        skip: 'No aplica',
        'in-study': 'En estudio de crédito',
        approved: 'Aprobado',
        rejected: 'Rechazado',
        interested: 'Interesado'
      },
      icon: {
        isHoverOn: {
          'non-applicable': false,
          'in-study': false,
          approved: false,
          rejected: false,
          payed: false
        },
        color: {
          disable: '#cccccc',
          enable: '#707070',
          onHover: '#00b19d'
        }
      }
    }
  },
  methods: {
    toggleRowPlus () {
      this.rowPlus = !this.rowPlus
    },
    openModal (status) {
      this.modal = { ...this.modal, show: true, status }
    },
    confirmHandler () {
      const { user: { idLocal: localLead }, modal: { status, observation, amount } } = this
      if (status === 'payed' && (!amount || !Number(amount))) {
        this.modal.amountError = 'Se debe ingresar un monto'
        this.modal.show = true
      } else {
        this.modal.show = false
        this.modal.amountError = ''
        this.$store.dispatch('leadStatuses', { localLead, status, observation, amount })
      }
    },
    isPossible (fromStatus, toStatus) {
      const allowedChangesFor = {
        interested: ['in-study', 'non-applicable'],
        'in-study': ['rejected', 'approved'],
        'non-applicable': [],
        rejected: [],
        approved: ['payed'],
        payed: []
      }

      return allowedChangesFor[fromStatus].filter(el => el === toStatus).length
    },
    isFinished (statusName, userStatus) {
      return ['non-applicable', 'rejected', 'payed'].filter(el => el === statusName).length === 1 && userStatus === statusName
    },
    iconColorHandler (statusName) {
      const { icon, user } = this

      return (icon.isHoverOn[statusName] && this.isPossible(user.status, statusName)) || this.isFinished(statusName, user.status) ? icon.color.onHover : this.isPossible(user.status, statusName) ? icon.color.enable : icon.color.disable
    }
  }
}
</script>

<style>
.tableRow-fade-enter-active {
  animation-direction: normal;
  animation-duration: .3s;
  animation-iteration-count: 1;
  animation-name: tableRow-fade;
  transition-timing-function: ease-in;
}

.tableRow-fade-leave-active {
  animation-direction: reverse;
  animation-duration: .3s;
  animation-iteration-count: 1;
  animation-name: tableRow-fade;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

@keyframes tableRow-fade {
  0% {
    max-height: 0px;
    opacity: 0;
    overflow: hidden;
    transform: scaleY(0);
  }
  100% {
    max-height: 100px;
    opacity: 1;
    overflow: hidden;
    transform: scaleY(1);
  }
}

.tableRow {
  display: flex;
  flex-direction: column;
}

.tableRow__main {
  align-items: center;
  display: flex;
  flex-direction: row;
  padding: 5px 0;
}

.tableRow__main__item1 {
  text-align: left;

  align-items: center;
  display: flex;
  flex-direction: row;
  width: calc(100% - 720px);
}

.tableRow__main__item1__icon-container {
  margin-right: 30px;
}

.tableRow__main__item1__icon-container__icon {
  width: fit-content;
}

.tableRow__main__item1__text {
  color: #00535e;
  font-size: 14px;
  font-weight: 400;
}

.tableRow__main__item2 {
  padding-left: 10px;
  width: 130px;
}

.tableRow__main__item2__text {
  color: #808080;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
}

.tableRow__main__item3 {
  width: 120px;
}

.tableRow__main__item3__text {
  background-color: #ededed;
  border-radius: 5px;
  width: 150px;
}

.tableRow__main__item4 {
  width: 160px;
}

.tableRow__main__item4__text {
  color: #808080;
  font-size: 14px;
  font-weight: 400;

  margin-left: 30px;
  width: 160px;
}

.tableRow__main__item5 {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-left: 30px;
  width: 130px;
}

.tableRow__main__item6__text {
  background-color: #ededed;
  border-radius: 5px;
  margin: 5px 0;
  margin-left: 10px;
  width: 140px;
}

.tableRow__main__item5__icon--default:hover {
  display: none;
}

.tableRow__main__item5__icon--whenHover {
  display: none;
}

.tableRow__main__item5__icon--whenHover:hover {
  display: block;
}

.tableRow__main__item6 {
  width: 30px;
}

.tableRow__main__item6__comment {
  width: 0px;
}

.tableRow__plus {
  background-color: #f2f2f2;
  border: 10px solid #cccccc21;
  margin: 20px 0;
  padding-top: 6.5px;
}

.tableRow__line {
  background-color: #00535e;
  height: 2px;
  left: -5px;
  position: relative;
  width: calc(100% + 10px);
}

.tableRow__line--gray {
  background-color: #b3b3b3;
  height: 2px;
  left: -5px;
  position: relative;
  width: calc(100% + 10px);
}

.tableRow__plus__header {
  display: grid;
  grid-gap: 2px;
  grid-template-columns: repeat(2, calc(50% - 122px)) 240px;
  padding: 0 2px;
}

.tableRow__plus__header__text__circle {
  color: #ffffff;
  font-size: 12px;
  font-weight: 400;

  background-color: #00535e;
  border-radius: 20px;
  padding: 2px 20px;
  width: fit-content;
}

.tableRow__plus__header__text {
  padding-left: 15px;
  text-align: left;
}
.tableRow__plus__header__text__down {
  color: #00535e;
  font-size: 12px;
  font-weight: 400;
  line-height: 32px;

  height: 20px;
}

.tableRow__plus__container {
  background-color: #cccccc;
  display: grid;
  grid-gap: 1px;
  grid-template-columns: repeat(2, calc(50% - 121px)) 240px;
  grid-template-rows: repeat(8, auto);
  margin-top: 5px;
  padding: 1px;
}

.tableRow__plus__container__item {
  color: #00535e;
  font-size: 12px;
  line-height: 35px;
  text-align: left;

  background-color: #ffffff;
  height: 29px;
  padding-left: 15px;
}

.tableRow__plus__container__item--gray {
  background-color: rgba(242,242,242, 1);
}

.tableRow__plus__container__item--contact {
  background-color: #ffffff;
  grid-column: 3/4;
  grid-row: 1/9;
}

.tableRow__plus__container__item--contact__profile {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding: 5px 0;
}

.tableRow__plus__container__item--contact__profile__pic {
  color: #ffffff;
  line-height: 35px;

  background-color: #4a90e2;
  border-radius: 50%;
  border-style: none;
  cursor: pointer;
  height: 35px;
  height: -moz-fit-content;
  height: -webkit-fit-content;
  width: 35px;
}

.tableRow__plus__container__item--contact__profile__data__name {
  color: #00535e;
  font-size: 16px;
  font-weight: 100;
}

.tableRow__plus__container__item--contact__profile__data__headline {
  color: #595959;
  font-size: 12px;
  font-weight: 100;
}

.tableRow__plus__container__item--contact__label {
  color: #b3b3b3;
  font-size: 12px;
  font-weight: 100;
  text-align: left;

  margin-top: 15px;
  padding: 0 15px;
}

.tableRow__plus__container__item--contact__text {
  color: #595959;
  font-size: 12px;
  font-weight: 100;

  padding: 0 15px;
  text-align: left;
}
</style>
